module.exports = __webpack_public_path__ + "img/zilla.6c3ac6af.svg";